const AutoLogout = () => null;

export default AutoLogout;
